import apiSlice from '..';

export type Resource = {
  resource: string;
  label: string;
};

export const RESOURCE_TO_ROUTE: Record<string, string> = {
  seller_invoice: '/admin/financials/invoices',
  buyer_fees: '/admin/financials/buyer-fees',
  declined_cards: '/admin/financials/declined-cards',
  additional_fees: '/admin/financials/additional-fees',
  transactions: '/admin/financials/transactions',
  auction_summary_report: '/admin/financials/auction-summary-report',
  lister_summary_report: '/admin/financials/lister-summary-report',
  accounts: '/admin/accounts',
  other_auction_buyers: '/admin/other-buyers',
  title_report: '/admin/financials/transfer-report',
  buyer_report: '/admin/financials/buyer-purchase-report'
};

const adminPermissionsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAdminResources: builder.query<Resource[], { job_title?: string } | void>({
      query: params => ({
        url: '/admin/resources',
        params: params?.job_title ? { job_title: params.job_title } : undefined
      }),
      transformResponse: (r: any) => r.data,
      providesTags: ['AdminResources']
    }),
    getAdminUserPermissions: builder.query<string[], number>({
      query: userId => `/admin/users/${userId}/permissions`,
      transformResponse: (r: any) => r.data,
      providesTags: (result, error, userId) => [{ type: 'AdminPermissions' as const, id: userId }]
    }),
    updateAdminUserPermissions: builder.mutation<string[], { userId: number; resources: string[] }>({
      query: ({ userId, resources }) => ({
        url: `/admin/users/${userId}/permissions`,
        method: 'PUT',
        body: { resources }
      }),
      transformResponse: (r: any) => r.data,
      invalidatesTags: (result, error, { userId }) => [{ type: 'AdminPermissions' as const, id: userId }]
    })
  })
});

export const { useGetAdminResourcesQuery, useGetAdminUserPermissionsQuery, useUpdateAdminUserPermissionsMutation } =
  adminPermissionsApi;
